<div class="tracking-page-tracking-details-container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white" [formGroupName]="'widgets'">
    <div class="card" [formGroupName]="'details'">
      <div class="header-container">
        <pdq-heading element="h5">Tracking details</pdq-heading>
        <pdq-slide-toggle formControlName="showTrackingDetails"></pdq-slide-toggle>
      </div>

      @if (formGroup?.get('widgets')?.get('details')?.get('showTrackingDetails')?.value) {
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="checkbox-with-input-container">
            <pdq-checkbox
              label="Show carrier-specific info"
              labelSize="small"
              icon="more_information"
              description="Orders that you don't have the ability to track or give indication of where the shipment is"
              formControlName="displayMessageForUntrackedShipments">
            </pdq-checkbox>
          </div>

          @if (formGroup?.get('widgets').get('details').get('displayMessageForUntrackedShipments')?.value) {
            <div class="input-wrapper" [ngStyle]="{ 'padding-left': '28px' }">
              <pdq-dropdown
                mode="default"
                class="dropdown"
                width="fit-content"
                [border]="true"
                [placeholder]="'Select'"
                [defaultOption]="defaultCarrierOptions"
                [options]="carrierOptions"
                multiSelect="true"
                selectBy="checked"
                formControlName="carriersToDisplayMessageFor"
                showSelectUnselectOptions="true"
                buttonFontSize="14"
                [control]="formGroup.get('widgets.details.carriersToDisplayMessageFor')"></pdq-dropdown>
            </div>

            <div class="input-wrapper" [ngStyle]="{ 'padding-left': '28px' }">
              <label [ngStyle]="{ fontSize: '14px', 'padding-top': '20px', 'padding-bottom': '5px' }">
                <span>Message To Display</span>
              </label>
              <pdq-textarea
                placeholder="Enter message..."
                [control]="formGroup.get('widgets.details.messageForUntrackedShipments')"
                rows="3">
              </pdq-textarea>
            </div>
          }
          @if (shop.metadata.trackingHandedOverToDifferentCarrierMetadata) {
            <div class="checkbox-with-input-container">
              <pdq-checkbox
                label="Display additional information when order is handed over to a different carrier"
                labelSize="small"
                formControlName="displayMessageWhenHandedOverToDifferentCarrier">
              </pdq-checkbox>
              @if (
                formGroup?.get('widgets').get('details').get('displayMessageWhenHandedOverToDifferentCarrier').value
              ) {
                <div class="input-wrapper">
                  <pdq-textarea
                    placeholder="Enter message..."
                    [control]="formGroup.get('widgets.details.messageWhenHandedOverToDifferentCarrier')"
                    rows="3">
                  </pdq-textarea>
                </div>
              }
            </div>
          }
          <pdq-checkbox label="Show delivery status" labelSize="small" formControlName="showDeliveryStatus">
          </pdq-checkbox>
          <pdq-checkbox label="Show tracking number" labelSize="small" formControlName="displayTrackingNumber">
          </pdq-checkbox>
          <pdq-checkbox
            label="Show full tracking history"
            labelSize="small"
            formControlName="showDetailedTrackingHistory">
          </pdq-checkbox>
        </div>
      }
    </div>
  </pdq-card>
</div>
